module.exports = __webpack_public_path__ + "static/media/big_R1_(10).2eb5f3c4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/big_R1_(10).jpg
// module id = 465
// module chunks = 0